// src/api/paymentGatewayApi.js
import axios from "axios";
import { Auth_Proto, Auth_Domain, Auth_Port } from "../Component/consts";

const api = axios.create({
    baseURL: `${Auth_Proto}${Auth_Domain}${Auth_Port}/api/masters`,
});

export const paymentGatewayApi = {
    getAll: () => api.get("/payment-gateways"),
    getById: (id) => api.get(`/payment-gateways/${id}`),
    create: (payload) => api.post("/payment-gateways", payload),
    update: (id, payload) => api.put(`/payment-gateways/${id}`, payload),
    delete: (id) => api.delete(`/payment-gateways/${id}`),
};